'use strict';

/**
 * Change server data to list data.
 *
 * @param {Array} data - data for prepare
 *
 * @return {Array} prepared data for LayoutList
 */
module.exports = function ( data ) {
    var result = [],
        titleText, dateText,
        className;

    data = data || [];

    data.forEach(function ( item ) {
        var genres = item.genres.map(function ( genre ) {
                return genre.name;
            }),

            $titleWrap = document.createElement('div'),
            $title     = document.createElement('div'),
            $text      = document.createElement('div');

        $title.className = 'name';
        $text.className = 'subData theme-text-disabled' + (genres.length ? ' visible' : '');
        $title.innerText = titleText = item.name || item['original_name'];
        $text.innerText = dateText = genres.join(', ');

        $titleWrap.appendChild($title);
        $titleWrap.appendChild($text);

        switch ( item['watched_status'] ) {
            case 'watched':
                className = 'theme-icon theme-icon-ok';
                break;
            case 'not_watched':
                className = 'theme-icon theme-icon-ok hidden';
                break;
            case 'not_ended':
                className = 'theme-icon theme-icon-ok disabled';
                break;
        }

        result.push({
            items: [
                {
                    name: '$title',
                    className: 'title',
                    value: $titleWrap,
                    htmlInstance: true,
                    realValue: {title: titleText, genre: dateText}
                },
                {
                    name: '$lock',
                    className: ((item.censored || (item.category && item.category.censored)) ?
                        'theme-icon theme-icon-lock disabled' : 'theme-icon theme-icon-lock disabled hidden')
                },
                {
                    name: '$favorite',
                    className: (item.favorite ?
                        'theme-icon theme-icon-favorite-active active' : 'theme-icon theme-icon-favorite-active active hidden')
                },
                {
                    name: '$status',
                    className: className
                }
            ],
            value: item
        });
    });

    return result;
};
